export default function TabMedia() {

  return (
    <div>                                    
        <div>
            <iframe width="100%"
                    height="360"                 
                    src="https://www.youtube.com/embed/B4NXg3vOYgI"
                    title="Oscillatory Motion of the V-Drive Prototype" 
                    frameborder="0"
                    allowfullscreen></iframe>
        </div>
        <div>  Oscillatory Motion of the V-Drive Prototype (Suspended Test) </div>
        <br />
        <div>
            <iframe width="100%"
                    height="360"   
                    src="https://www.youtube.com/embed/kykpPTvRIrc"
                    title="V-Drive ScaleTest" 
                    frameborder="0"
                    allowfullscreen></iframe>
        </div>
        <div>  V-Drive ScaleTest</div>
            <br />
        <div>
            <iframe width="100%"
                    height="360"
                    src="https://www.youtube.com/embed/95GC_-tvuQs"
                    title="V-Drive: laboratory-scale test" 
                    frameborder="0"
                    allowfullscreen></iframe>
        </div>
        <div>V-Drive: laboratory-scale test</div>
            <br />     
  </div>  

  )
}
